import { Component, Host, h, Element, Prop, Watch } from '@stencil/core';

export interface AhaTabPanels extends HTMLAhaTabPanelsElement {}

/**
 * `aha-tab-panels` is a container of one or many `aha-tab-panel` components and can be used inside `aha-tabs` to create smart tabs.
 * @slot Default - Contents of `aha-tab-panels`
 */
@Component({
  tag: 'aha-tab-panels',
  styleUrl: 'aha-tab-panels.css',
  shadow: true,
})
export class AhaTabPanels {
  @Element() host!: HTMLAhaTabPanelsElement;

  componentDidLoad() {
    // Update the panel in the first render.
    this.updateTabPanels(this.visibleIndex);
  }

  /**
   * Indicates the visible index.
   */
  @Prop() visibleIndex: number = -1;

  /**
   * Watches for changes in visibleIndex and updates the panels
   */
  @Watch('visibleIndex')
  showPanels(newVisibleIndex: number) {
    this.updateTabPanels(newVisibleIndex);
  }

  private updateTabPanels(visibleIndex: number) {
    this.tabPanels.forEach((tabPanel, index) => {
      if (visibleIndex === index) {
        tabPanel.removeAttribute('hidden');
      } else {
        tabPanel.setAttribute('hidden', 'true');
      }
    });
  }

  private get tabPanels() {
    return this.host.querySelectorAll('aha-tab-panel');
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
